import React from "react";
import { Icon, Reveal, Overline } from "./primitives";
import { CAPABILITIES } from "../../data/content";

export default function Capabilities() {
  return (
    <section className="relative bg-[#FAFAFA] py-20 sm:py-28" data-testid="section-capabilities">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <Overline>Platform capabilities</Overline>
            <h2 className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-ajmus-ink sm:text-5xl">
              Engineered for real operations.
            </h2>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
          {CAPABILITIES.map((c, i) => (
            <Reveal key={c.title} delay={(i % 2) * 0.06}>
              <div className="flex items-center gap-4 rounded-2xl border border-black/5 bg-white px-5 py-4 transition-transform transition-shadow duration-300 ease-out hover:-translate-y-0.5 hover:shadow-[0_14px_40px_rgb(11,19,43,0.06)]">
                <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-ajmus-navy/5 text-ajmus-royal">
                  <Icon name={c.icon} size={20} />
                </span>
                <span className="text-sm font-semibold text-ajmus-ink sm:text-base">{c.title}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
